import { Field, FieldProps } from "formik"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { Form } from "~/components/Form/Form"
import { FormSubmitSection } from "~/components/FormSubmitSection/FormSubmitSection"
import { FormInput } from "~/components/Input/Input"

import { PopupCategories } from "../PopupCategories/PopupCategories"
import styles from "./index.module.css"

type Props = {
  children?: React.ReactNode
  code?: string
  classNameBottomWrapper?: string
  classNameInput?: string
  buttonView?: "xl" | "xs"
  categoriesList?: { id: string; code: string; name: string }[]
  returnValuesType?: "id" | "code" | "name"
}

export const Subscription: React.FC<Props> = ({
  code,
  classNameBottomWrapper,
  categoriesList,
  returnValuesType,
  classNameInput,
}) => {
  const { t } = useTranslation()
  const [stateCategories, setStateCategories] = useState<string[]>([])

  return (
    <Form
      initialValues={{ email: "", code: code ? code : '["empty"]' }}
      url="/subscriptionform/submit"
    >
      {!code && categoriesList && returnValuesType && (
        <div className={styles.Categories}>
          <Field>
            {({ form: { setFieldValue } }: FieldProps) => {
              const onChange = (v: string[]): void => {
                const fieldValues: string[] = []

                v.forEach((el) => {
                  fieldValues.push(`"${el}"`)
                })

                setFieldValue("code", `[${fieldValues}]`)
                setStateCategories(v)
              }

              return (
                <PopupCategories
                  categoriesList={categoriesList}
                  returnValuesType={returnValuesType}
                  state={stateCategories}
                  onChange={onChange}
                />
              )
            }}
          </Field>
        </div>
      )}

      <FormInput className={classNameInput} label="Email" name="email" />

      <FormSubmitSection
        buttonLabel={t("Subscription.Button")}
        className={classNameBottomWrapper}
      />
    </Form>
  )
}
